import type { DriverProfilePublicDto } from '@posilka/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './client';

export const useDriverProfile = (userId: string) =>
  useQuery({
    queryKey: ['driver-profile', userId],
    queryFn: () => api<DriverProfilePublicDto>(`/drivers/${userId}`),
    staleTime: 5 * 60_000,
  });
